import { Grid } from "theme-ui";
import "../style/TradesDistribution.css";

const TradesDistributionSkelton = () => {
    return (
        <div className="td-skel-card">

            <div className="td-skel-chart skeleton"></div>

            <Grid columns={[2]} className="td-skel-legend">
                <div className="td-skel-legend-item skeleton"></div>
                <div className="td-skel-legend-item skeleton"></div>
                <div className="td-skel-legend-item skeleton"></div>
                <div className="td-skel-legend-item skeleton"></div>
                <div className="td-skel-legend-item skeleton"></div>
            </Grid>
        </div>
    );
};

export default TradesDistributionSkelton;
